const projectRouter = [
    // 主页
    {
      path: '/project',
      name: 'project',
      component: () => import('@/views/project/index.vue')
    },
    // 审批流程
    {
     path: '/projectDetail',
     name: 'projectDetail',
     component: () => import('@/views/project/projectDetail.vue')
   },
    // 审批流程
    {
     path: '/completenessRate',
     name: 'completenessRate',
     component: () => import('@/views/project/completenessRate.vue')
   },
  ]
  export default projectRouter